import { TableFilterButtons, TableFilterCard, TableFilterSection } from '@repo/ui/Table';
import { TextInputField, SelectorInputField } from '@repo/ui/Form';
import { registerInput } from '@repo/hooks/useZodForm';
import { useZodFormContext } from '@repo/hooks/useZodFormContext';

import React from 'react';
import { useFormState } from 'react-hook-form';

const CampaignsTableFilter = () => {
  const filter = useZodFormContext();
  useFormState();
  if (!filter) {
    return <></>;
  }
  return (
    <TableFilterCard>
      <TableFilterSection>
        <TextInputField label="Campaign ID" {...registerInput(filter, 'tcr_campaign_id')} />

        <SelectorInputField
          label="Use case"
          options={[
            { label: 'All', value: '' },
            { label: '2FA', value: '2FA' },
            { label: 'Account Notifications', value: 'ACCOUNT_NOTIFICATION' },
            { label: 'Agents and Franchises', value: 'AGENTS_FRANCHISES' },
            { label: 'Carrier Exemptions', value: 'CARRIER_EXEMPTIONS' },
            { label: 'Charity', value: 'CHARITY' },
            { label: 'Customer Care', value: 'CUSTOMER_CARE' },
            {
              label: 'Delivery Notifications',
              value: 'DELIVERY_NOTIFICATION',
            },
            { label: 'Emergency', value: 'EMERGENCY' },
            { label: 'Fraud Alert Messaging', value: 'FRAUD_ALERT' },
            { label: 'Higher Education', value: 'HIGHER_EDUCATION' },
            { label: 'K-12 Education', value: 'K12_EDUCATION' },
            { label: 'Low Volume Mixed', value: 'LOW_VOLUME' },
            { label: 'Marketing', value: 'MARKETING' },
            { label: 'Mixed', value: 'MIXED' },
            { label: 'Political', value: 'POLITICAL' },
            { label: 'Polling and Voting', value: 'POLLING_VOTING' },
            { label: 'Proxy', value: 'PROXY' },
            { label: 'Security Alert', value: 'SECURITY_ALERT' },
            { label: 'Social', value: 'SOCIAL' },

            { label: 'Sweepstakes', value: 'SWEEPSTAKES' },
          ]}
          {...registerInput(filter, 'usecase')}
        />
        <SelectorInputField
          label="Status"
          options={[
            { label: 'Active', value: 'Active' },
            { label: 'Inactive', value: 'Inactive' },
            { label: 'All', value: 'All' },
          ]}
          {...registerInput(filter, 'active')}
        />
      </TableFilterSection>

      <TableFilterButtons className="self-end" />
    </TableFilterCard>
  );
};

export default CampaignsTableFilter;
